<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import url from './common/common.js'
export default {
  name: 'App',
  components: {
    url
  }
}
</script>

<style scoped>
#app{ background: #fff; min-height: 100%; font-family: 'Arial,Microsoft YaHei'!important;}
</style>



// WEBPACK FOOTER //
// src/App.vue